import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import routes from '../../routes/routes'
import { RootState } from '../../store'
import { replaceLimit, replacePage, replaceSearch } from './CustomLabels.slice'
import { paginate, deleteCustomLabel } from './CustomLabels.thunk'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import confirmService from '../../services/confirm.service'
import printService from '../../services/print.service'
import customLabelApi from '../../apis/customLabel.api'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import HeadingRow from '../../components/HeadingRow'
import DataTable from '../../components/DataTable'
import Gallery from '../../components/Gallery'
import storageService from '../../services/storage.service'

interface Props
  extends RouteComponentProps, ConnectedProps<typeof connector> {}

class CustomLabels extends Component<Props> {

  constructor (props: Props) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  headers: TableHorizontalHeader[] = [
    { heading: i18n("Name"), path: 'name' },
    { heading: i18n("Item"), path: 'item.code' },
    { heading: i18n("CSV"), downloadText: 'csvFilename', path: 'downloadUrls.csv' },
    { heading: i18n("API"), downloadText: 'apiUrl', path: 'downloadUrls.api' },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true
    },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true
    },
    { heading: i18n("Actions") },
    { heading: i18n("Snapshot"), path: 'snapshot' },
  ]

  handleLimitChange = (limit: string) => {
    storageService.set('customLabelLimit',limit);
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    storageService.set('customLabelSearch',search);
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    storageService.set('customLabelPage',page);
    this.props.replacePage(page)
  }

  handleCreateClick () {
    this.props.history.push(routes.customLabelCreate)
  }
  
  handleActionClick = (id: number, action: ActionName) => {
    if (action === 'view') {
      const pathname = routes.customLabel
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'list') {
      const pathname = routes.customLabelPrintsPaginate
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'print') {
      const pathname = routes.customLabelPrint
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'design') {
      const pathname = routes.labelBuilder
      const state = { customLabelId: id }
      this.props.history.push({ pathname, state })
    } else if (action === 'preview') {
      customLabelApi.preview(id, markup => {
        if (!markup) return
        printService.printMarkups([markup])
      })
    } else if (action === 'edit') {
      const pathname = routes.customLabelEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the custom label?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.props.deleteCustomLabel(id)
      }
      confirmService.push(confirm)
    }
  }

  componentDidMount () {
    storageService.set("customLabelSearch","");
    storageService.set("customLabelPage","");
    storageService.set("customLabelLimit","");
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow heading={i18n("Custom Labels Gallery")}>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <Gallery
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.customLabels
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  deleteCustomLabel,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(CustomLabels))
